import { createReduxEnhancer } from '@sentry/react';

/**
 * On peut ajouter des action & state transformers en paramètres
 * https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/
 */
const sentryReduxEnhancer = createReduxEnhancer();

export default sentryReduxEnhancer;
